import { createRoot } from "react-dom/client";
import App from "./app/App.tsx";
import "./styles/index.css";
import { initAnalyticsIfConsented } from "./lib/analytics";

initAnalyticsIfConsented();

createRoot(document.getElementById("root")!).render(<App />);
  